// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { catchError, takeWhile } from 'rxjs/operators';
import { Vehicle, VehicleCreation } from '@interfaces/vehicle.interfaces';
import { VehicleService } from '@services/vehicle.service';
import { AppEvent } from '@interfaces/interfaces';
import { of } from 'rxjs';

@Component({
    selector: 'vehicle-form-component',
    templateUrl: './vehicle-form.component.html',
    styleUrls: ['./vehicle-form.component.scss'],
})
export class VehicleFormComponent implements OnDestroy {
    @Output() vehicleSelected$ = new EventEmitter();
    private isComponentAlive = true;
    public isFiltered = false;
    public vehicleSearch = false;

    vehicle: VehicleCreation = this.getVehicleDefaults();
    vehicles: Vehicle[] = [];
    vehicleForm: FormGroup;
    loading = false;

    constructor(private readonly vehicleService: VehicleService) {}

    public eventHandler(event: AppEvent): void {
        switch (event.context) {
            case 'query':
                this.vehicleSearch = true;
                this.loading = true;
                this.searchVehicle(event.data);
                break;
            default:
                break;
        }
    }

    getVehicleDefaults(): VehicleCreation {
        return {
            vin: 'none',
            trim: 'none',
            year: 0,
            model: 'Model',
            make: 'Make',
            stockNumber: 'none',
            bodyStyle: 'none',
            vehicleExt: {},
            manuallyCreated: false,
        };
    }

    searchVehicle(query: string) {
        if (query) {
            this.isFiltered = true;
            this.vehicleService
                .searchForVehicle$(query)
                .pipe(
                    catchError((error) => {
                        this.vehicle = null;
                        this.vehicleSelected$.emit(null);
                        this.loading = false;
                        return of(null);
                    }),
                    takeWhile(() => this.isComponentAlive)
                )
                .subscribe((vehicles: Vehicle[]) => {
                    this.vehicles = vehicles;
                    this.loading = false;
                });
        } else {
            this.vehicles = [];
            this.loading = false;
            this.vehicleSearch = false;
            this.isFiltered = false;
        }
    }

    clearVehicleForm() {
        this.vehicles = undefined;
        this.vehicle = null;
        this.vehicleSelected$.emit(null);
    }

    vehicleSelected(vehicle: Vehicle) {
        this.vehicle = {
            ...vehicle,
            manuallyCreated: false,
        };
        this.vehicleSelected$.emit(this.vehicle);
        this.vehicles = this.vehicles.filter((v) => v.vin === this.vehicle.vin);
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
